



































import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbAlert, mdbSelect, mdbIcon } from '@folky-tools/mdbvue';
import { RedsysPaymentConfig, RedsysEnvironmentType } from '@/models/common/redsys-payment-config';
import { requiredIf } from 'vuelidate/lib/validators';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbAlert,
        mdbSelect,
        mdbIcon
    },
    validations: {
        redsysPaymentConfig: {
            merchantCode: {
                required: requiredIf(model => {
                    return model.creditCardEnabled || model.bizumEnabled;
                })
            },
            password: {
                required: requiredIf(model => {
                    return model.creditCardEnabled || model.bizumEnabled;
                })
            }
        }
    }
})
export default class EditRedsysPaymentConfig extends Vue {
    @Prop(RedsysPaymentConfig)
    private redsysPaymentConfig!: RedsysPaymentConfig;
    private environments: any[] = [];

    private mounted(): void {
        for (const n in RedsysEnvironmentType) {
            if (typeof RedsysEnvironmentType[n] === 'number') {
                this.environments.push({
                    value: RedsysEnvironmentType[n],
                    text: this.$i18n.t(`components.businesses.editRedsysPaymentConfig.redsysEnvironment.${n.toString()}`),
                    selected: n === RedsysEnvironmentType[this.redsysPaymentConfig.environment!]
                });
            }
        }

        if (!this.redsysPaymentConfig.environment) {
            this.environments[RedsysEnvironmentType.Live].selected = true;
        }
    }

    private hasErrors(): boolean {
        this.$v.redsysPaymentConfig.$touch();
        if (this.$v.redsysPaymentConfig.$error) {
            return true;
        }
        return false;
    }

    private onChangeEnvironment(value: number, text: string) {
        this.redsysPaymentConfig.environment = value;
    }
}
